export const SLIDER_ITEMS_LENGTH = 20;

export const LIMIT = 30;

export const CASINO_TYPE_FOR_REQUEST = {
  casino: 'casino',
  casinoLive: 'live',
  instantGames: 'instant'
};

export const DEFAULT_SLIDER_INTERVAL = 3;
